 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {matchPath} from 'react-router-dom'

import {MENTIONEE} from '../../utils/constants'


const popInvolvementToast = (
  notification,
  {atmosphere, history}
) => {
  if (!notification) return
  const {
    involvement,
    changeAuthor: {preferredName: changeAuthorName},
    task,
    team
  } = notification
  if (!task) return
  const {id: taskId} = task
  const {id: teamId} = team
  const {pathname} = window.location
  const inMeeting = !!matchPath(pathname, {
    path: '/meet',
    exact: false,
    strict: false
  })
  if (inMeeting) return

  const wording = involvement === MENTIONEE ? 'mentioned you in' : 'assigned you to'
  const message = `${changeAuthorName} ${wording} a task`
  atmosphere.eventEmitter.emit('addSnackbar', {
    key: `taskInvolvement:${taskId}`,
    autoDismiss: 10,
    message,
    action: {
      label: 'Check it out!',
      callback: () => {
        _optionalChain([history, 'optionalAccess', _ => _.push, 'call', _2 => _2(`/team/${teamId}`)])
      }
    }
  })
}

export default popInvolvementToast
